import { Route, Routes as RouterRoutes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import AuthRoute from "../../components/AuthRoute";
import { createModuleErrorBoundary } from "../../components/ErrorBoundary";
import PrimaryNav from "./components/PrimaryNav";
import routes from "./routes";
import { useFormik } from "formik";

const Body = props => {
  return (
    <Sentry.ErrorBoundary
      fallback={createModuleErrorBoundary("warehouse")}
      beforeCapture={scope => {
        scope.setTag("module", "warehouse");
      }}
    >
      <RouterRoutes>
        {routes?.map((item, index) => {
          return (
            <Route
              key={index}
              path={item?.path}
              element={
                <AuthRoute permissions={item.permissions}>
                  <item.element {...props} />
                </AuthRoute>
              }
            />
          );
        })}
      </RouterRoutes>
    </Sentry.ErrorBoundary>
  );
};

const Warehouse = props => {
  const formik = useFormik({
    initialValues: {},
  });

  return (
    <>
      <PrimaryNav formik={formik} />
      <Body formik={formik} {...props} />
    </>
  );
};

export default Warehouse;
